module.exports = class RefCounter {
  constructor() {
    this.counts = new Map();
  }

  increment(key) {
    const value = (this.counts.get(key) || 0) + 1;
    this.counts.set(key, value);
    return value;
  }

  decrement(key) {
    const value = (this.counts.get(key) || 0) - 1;
    if (value <= 0) {
      this.counts.delete(key);
      return 0;
    }
    this.counts.set(key, value);
    return value;
  }

  get(key) {
    return this.counts.get(key) || 0;
  }

  keys() {
    return [...this.counts.keys()];
  }

  getTotal() {
    return [...this.counts.values()].reduce((sum, value) => sum + value, 0);
  }
};
